import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Box, Dialog, DialogActions, DialogContent, Divider, Grid, Slide, Toolbar, } from '@mui/material';
import { Button } from '~/views/atoms/button';
import { forwardRef, useCallback, useMemo } from 'react';
import { UIService } from '~/services/service.ui';
import { t } from 'i18next';
import { useService } from '~/services/service.base';
import { FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import { plainToModel } from '~/tools/plain.model';
import { useFormikModel } from '~/tools/formik.model';
import { FormSortingPanel } from '~/views/molecules/form-sorting-panel';
import { CloseButton } from 'src/views/molecules/dialog-buttons/close-button';
import { ServiceSorting } from '~/services/service.sorting';
import { ModelSortingPanel } from '~/models/model.sorting.panel';
import { ServiceMediaCategories } from '~/services/service.media.categories';
import { runInAction } from 'mobx';
import { useStyles } from '~/views/organisms/sorting-panel/styles';
const Transition = forwardRef(function Transition(props, ref) {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
const sxToolbar = { height: UIService.TOOLBAR_SEARCH_HEIGHT, justifyContent: 'space-between', gap: 0 };
export const SortingPanel = () => {
    const navigate = useNavigate();
    const classes = useStyles();
    const sortingService = useService(ServiceSorting);
    const categoryService = useService(ServiceMediaCategories);
    const onSubmit = useCallback((value) => {
        sortingService.openSortingService.handleClose();
        runInAction(() => categoryService.setSorting(value.sortingOption));
        navigate(ROUTES.FUNDS.MEDIA.path);
    }, [categoryService, navigate, sortingService.openSortingService]);
    const initialValues = useMemo(() => plainToModel(ModelSortingPanel, { sortingOption: categoryService.sorting }), [categoryService.sorting]);
    const formik = useFormikModel(ModelSortingPanel, {
        initialValues,
        onSubmit,
        validateOnMount: true,
        validateOnChange: true,
    });
    return (_jsx(FormikProvider, { value: formik, children: _jsxs(Dialog, { id: 'sorting-panel-dialog', className: classes.dialogContainer, fullScreen: true, open: sortingService.openSortingService.open, TransitionComponent: Transition, children: [_jsxs(AppBar, { color: "inherit", position: "relative", children: [_jsxs(Toolbar, { sx: sxToolbar, children: [_jsx(Box, { width: 40 }), _jsx(Box, { className: classes.title, children: t('CATEGORY_SORTING_PANEL_TITLE') }), _jsx(Box, { height: 40, width: 40, children: _jsx(CloseButton, { closeButtonHandler: sortingService.openSortingService.handleClose }) })] }), _jsx(Divider, {})] }), _jsx(DialogContent, { children: _jsx(FormSortingPanel, {}) }), _jsx(DialogActions, { children: _jsx(Grid, { container: true, flexDirection: "column", children: _jsx(Grid, { item: true, className: classes.button, children: _jsx(Button, { fullWidth: true, onClick: formik.submitForm, children: t('MEDIAS_FILTERS_ENREGISTRER') }) }) }) })] }) }));
};
